var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAlert(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "svgStroke",
    strokeWidth: 0.691,
    d: "M3.664 6.345C5.147 3.721 5.888 2.41 6.906 2.071a2.73 2.73 0 0 1 1.722 0c1.018.338 1.76 1.65 3.242 4.274 1.483 2.624 2.225 3.936 2.002 5.005a2.862 2.862 0 0 1-.861 1.524c-.795.732-2.278.732-5.244.732-2.966 0-4.449 0-5.244-.732a2.862 2.862 0 0 1-.861-1.524c-.222-1.069.519-2.38 2.002-5.005Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "svgStroke",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.922,
    d: "M7.762 10.226h.006"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "svgStroke",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.691,
    d: "M7.767 8.383V5.926"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlert);
export default __webpack_public_path__ + "static/media/alert.1cda807ebfc71e75f19184da67a36bc7.svg";
export { ForwardRef as ReactComponent };